export default theme => ({
    accordionSummary: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    accordionText: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    accordionButtons: {
        flexGrow: 1,
        maxWidth: '100% !important',
        display: 'flex',
        justifyContent: 'flex-end'
    },
    acordionDetails: {
        display: 'block'
    }
});